import { Role } from 'src/types';

// Reusable role groups — the single source of truth for route guards, tab
// visibility, and Sidebar menu access so those views cannot drift apart.
const SUPER_SUPPORT: Role[] = [Role.SuperAdmin, Role.Support];
const ANALYST_UP: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst];
const STANDARD_ADMINS: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst, Role.ClientAdmin];
const MANAGER_ADMINS: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst, Role.ClientAdmin, Role.Manager];
const VIEW_INCL_ADMINS: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst, Role.ClientAdmin, Role.Viewer];
const ALL_EXCEPT_CO: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.Viewer,
  Role.ClientAdmin,
  Role.Manager,
];
const ALL: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.Viewer,
  Role.ClientAdmin,
  Role.Manager,
  Role.CustomerOperations,
];
const ALL_EXCEPT_VIEWER: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.ClientAdmin,
  Role.Manager,
  Role.CustomerOperations,
];

// Keys correspond to `RoutePath` members. Lookups are membership-based, so
// array order is not significant for guard/menu behaviour. Entries whose
// sidebar path is conditional on view/edit mode (e.g. PDP connection,
// Additional options) are keyed by the edit-root RoutePath member; the
// allowList is identical for both view and edit modes.
export const routeAccess = {
  // Top-level guarded branches (consumed by RootRouter)
  configurationRoot: ALL_EXCEPT_CO,
  dataManagementRoot: ALL,
  analyticsRoot: ALL_EXCEPT_CO,
  productInfo: SUPER_SUPPORT,

  // Configuration — General Settings
  configurationGeneralSettingsRoot: VIEW_INCL_ADMINS,
  configurationGeneralSettingsList: STANDARD_ADMINS,
  configurationGeneralSettingsEditRoot: VIEW_INCL_ADMINS,
  configurationGeneralSettingsEditPDPConnectionRoot: ALL_EXCEPT_CO,
  configurationGeneralSettingsEditPDPConnectionClientInformation: ANALYST_UP,
  configurationGeneralSettingsEditPDPConnectionPublishRoot: ALL_EXCEPT_CO,
  configurationGeneralSettingsEditPDPConnectionRegistrationRoot: VIEW_INCL_ADMINS,
  configurationGeneralSettingsEditPDPConnectionEngineConfiguration: VIEW_INCL_ADMINS,
  configurationGeneralSettingsEditPDPConnectionBankHolidays: ANALYST_UP,
  configurationGeneralSettingsEditPDPConnectionSynchronisationAudit: VIEW_INCL_ADMINS,
  configurationGeneralSettingsEditPDPConnectionAudit: ANALYST_UP,
  configurationGeneralSettingsEditAdditionalOptions: ANALYST_UP,
  configurationGeneralSettingsEditComplexMatchingRoot: MANAGER_ADMINS,
  configurationGeneralSettingsEditComplexMatchingEditRules: ANALYST_UP,
  configurationGeneralSettingsEditPGPKeyConfigurationRoot: STANDARD_ADMINS,

  // Configuration — Matching
  configurationMatchingRoot: ALL_EXCEPT_CO,
  configurationMatchingPolicyMain: ALL_EXCEPT_CO,
  configurationMatchingPolicyReview: STANDARD_ADMINS,
  configurationMatchingPolicyEditRoot: MANAGER_ADMINS,
  configurationMatchingPolicyCreateRoot: MANAGER_ADMINS,
  configurationMatchingDefaultPolicyCreateRoot: STANDARD_ADMINS,
  configurationMatchingTestRoot: MANAGER_ADMINS,

  // Configuration — Publish / PDP
  configurationPublishConfigurationRoot: STANDARD_ADMINS,
  configurationPDPAuditRoot: ANALYST_UP,
  configurationPDPSynchronisationManagementRoot: ANALYST_UP,

  // Data Management — children
  dataManagementHistoryRoot: MANAGER_ADMINS,
  dataManagementUploadSourceData: MANAGER_ADMINS,
  dataManagementMemberEditRoot: ALL_EXCEPT_VIEWER,

  // Analytics & Reports — children
  analyticsPossibleMatches: ALL_EXCEPT_CO,
  analyticsPensionValuesSlaRoot: ALL_EXCEPT_CO,
  analyticsMemberExtract: ALL_EXCEPT_CO,
  analyticsPensionLogs: ALL_EXCEPT_CO,
  analyticsExtractAuditRoot: ALL_EXCEPT_CO,
};
